import { ca } from '@cian/analytics';

export function trackOffersReliableLabelClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label,
    useLastProducts: true,
  });
}
